import { render } from "./ProductBrandComponent.vue?vue&type=template&id=6c8f3052&scoped=true"
import script from "./ProductBrandComponent.vue?vue&type=script&lang=js"
export * from "./ProductBrandComponent.vue?vue&type=script&lang=js"

import "./ProductBrandComponent.vue?vue&type=style&index=0&id=6c8f3052&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8f3052"],['__file',"resources/js/components/frontend/home/ProductBrandComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c8f3052"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c8f3052', __exports__)) {
    api.reload('6c8f3052', __exports__)
  }
  
  module.hot.accept("./ProductBrandComponent.vue?vue&type=template&id=6c8f3052&scoped=true", () => {
    api.rerender('6c8f3052', render)
  })

}


export default __exports__